import axios from 'axios'
import { Message, MessageBox, Loading } from 'element-ui'
import { getStorage, removeStorage } from '@/utils/storage'

let loadingInit = null
const baseURL = process.env.BASE_API

const service = axios.create({
  baseURL,
  timeout: 30000
})

service.interceptors.request.use( // 请求拦截器
  config => { // 请求前拦
    if (config.loading) {
      loadingInit = Loading.service({
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
    }
    if (config.method === 'get') config.params = JSON.parse(JSON.stringify(config.data))

    const token = getStorage('token') || ''
    if (token && !config.authCode) config.headers['token'] = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : token
    if (config.authCode) config.headers['Auth'] = config.authCode
    // config.headers["content-type"] = 'multipart/form-data;'
    config.transformResponse = [ // 返回数据处理
      data => {
        // 超过 JS 安全整数的 id 先转成字符串，避免精度丢失（如一级/二级代理角色 id）
        const safeData = String(data).replace(
          /([:\[,]\s*)(\d{16,})(\s*[,\}\]])/g,
          '$1"$2"$3'
        )
        return JSON.parse(safeData)
      }
    ]

    return config
  },
  error => { // do something with request error
    console.log('请求异常：', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use( // 响应拦截器
  response => {
    if (loadingInit) loadingInit.close()
    if (response.config.authCode) {
      const { errorCode = 0, description = '' } = response.data || {}
      if (errorCode === 0) return response.data
      else {
        Message({
          message: description || '未知错误，请联系管理员！',
          type: 'error',
          duration: 2000
        })
        return Promise.reject(new Error(description || '未知错误，请联系管理员！'))
      }
    } else {
      const res = response.data
      if (res.code === 0) return res
      else if (res.code === 400) {
        removeStorage()
        MessageBox.confirm(`登录超时，请重新登录！`, {
          type: 'error',
          showCancelButton: false
        }).then(() => {
          window.history.go(0)
        }).catch(action => {
          window.history.go(0)
        })
        return Promise.reject(new Error(res.msg))
      } else {
        Message({
          message: res.msg || '未知错误，请联系管理员！',
          type: 'error',
          duration: 2000
        })
        return Promise.reject(new Error(res.msg))
      }
    }
  },
  error => {
    console.log(console)
    if (loadingInit) loadingInit.close()
    Message({
      message: '服务器繁忙，请稍后尝试！',
      type: 'error',
      duration: 2000
    })
    return Promise.reject(error)
  }
)
export default service

function request (url, data = {}, loading = true, method = 'post', authCode = '') {
  return service({ url, data, loading, method, authCode })
}

export {
  request
}



// WEBPACK FOOTER //
// ./src/utils/request.js